import "./App.css"
// import Header from "./components/common/header/Header"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import Footer from "./components/common/footer/Footer"
import Home from "./components/home/Home"
import Admission from "./components/home/admission/admission"
import BSAdmission from "./components/home/admission/bsadmission"
function App() {
  return (
    <>
      {<Router>
        {/* <Header /> */}
        <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path='/admission' component={Admission} />
          <Route exact path='/bsadmission' component={BSAdmission}/>
         </Switch>
        <Footer />

      </Router>}
      {/* <Admission/> */}
    </>
  )
}

export default App
